import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import BoardingGroupForm from './BoardingGroupForm';
import NoDataResource from '../../../../common/resource/NoDataResource';
import Loader from '../../../../common/Loader';
import { BOARDING_GROUP_PATH } from '../../../../../config/paths';
import Content from '../../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../../common/resource/proptypes/CommonPropTypes';
import { clearBoardingGroup, getBoardingGroup, putBoardingGroup } from '../../../../../actions/itinerary/BoardingGroup';

const EditBoardingGroup = ({
  breadcrumbs,
  dispatchGetBoardingGroup,
  dispatchClearBoardingGroup,
  dispatchPutBoardingGroup,
  match: {
    params: { id: boardingGroupId },
  },
  loading,
  boardingGroup,
}) => {

  useLayoutEffect(() => {
    dispatchGetBoardingGroup({ boardingGroupId });
    return () => dispatchClearBoardingGroup();
  }, []);

  const onSubmit = (formValues) => {
    const locationIdList = formValues.locationList.map(location => location.value);
    const newFormValues = {
      ...formValues,
      locationIdList,
      boardingGroupId,
      routeId: formValues.route ? formValues.route.value : null,
    }
    dispatchPutBoardingGroup(newFormValues);
  };

  const generateInitialValues = ({ name, boardingGroupLocations, active, route }) => ({
    name,
    locationList: boardingGroupLocations.map(boardingGroupLocation => ({
      value: boardingGroupLocation.locationId,
      label: boardingGroupLocation.location.name,
    })),
    active,
    route: {
      value: route.id,
      label: route.name
    }
  });

  let content = null;

  if (loading) content = <Loader />;
  else if (boardingGroup.isEmpty())
    content = <NoDataResource returnPage={BOARDING_GROUP_PATH} />;
  else {
    content = (
      <BoardingGroupForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(boardingGroup.toJS())}
        isEdit
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Grupo de Embarque"
      subtitle="Editar grupo de embarque existente"
      content={content}
    />
  )
}

EditBoardingGroup.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetBoardingGroup: PropTypes.func.isRequired,
  dispatchClearBoardingGroup: PropTypes.func.isRequired,
  dispatchPutBoardingGroup: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  loading: PropTypes.bool,
  boardingGroup: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditBoardingGroup.defaultProps = {
  loading: false,
};

const mapStateToProps = (
  { ItineraryUnit }, { match: { params: { id: boardingGroupId } } }
) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Grupos de Embarque',
      href: BOARDING_GROUP_PATH,
    },
    {
      text: 'Ver',
      href: `${BOARDING_GROUP_PATH}/${boardingGroupId}`,
    },
    {
      text: 'Editar',
      href: '',
    }
  ],
  boardingGroup: ItineraryUnit.BoardingGroup.getIn(['current', 'content']),
  loading: !ItineraryUnit.BoardingGroup.getIn(['current', 'activity']).isEmpty(),
})

const mapDispatchToProps = {
  dispatchGetBoardingGroup: getBoardingGroup,
  dispatchClearBoardingGroup: clearBoardingGroup,
  dispatchPutBoardingGroup: putBoardingGroup,
}

export default connect(mapStateToProps, mapDispatchToProps)(EditBoardingGroup);